import axios from 'axios';

export default class PeriodoService {

    getPeriodo() {            
        const url = process.env.VUE_APP_APIURL + `/api/periodo`;    
        return axios.get(url).then(res=>res.data);
    }

   
}